import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import { configureAuth, getEnterpriseConnectionWithPathname } from '../app-auth';
import LoadingPage from '../containers/loading-container';
import LoginPage from '../containers/login/auth0-login';
import { RootState } from '../modules';
import { authSelectors } from '../modules/auth';
import { saveEnterpriseConnection } from '../services/local-storage-service';
import { useForgeNewExperienceParam } from '../utils/hooks';

function ForgeOptOutHandler({ children }: { children: React.ReactNode }) {
  useForgeNewExperienceParam();
  return <>{children}</>;
}

type DispatchProps = {};

const mapStateToProps = (state: RootState) => ({
  isTokenExpired: authSelectors.isAuthTokenExpired(state),
  authUser: state.auth.authUser,
});
type StateProps = ReturnType<typeof mapStateToProps>;

type Props = DispatchProps & StateProps & RouteComponentProps<any>;

export class BaseLayer extends React.Component<Props, {}> {
  appAuth = configureAuth();

  componentDidMount() {
    this.persistEnterpriseConnectionFromPath();
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.persistEnterpriseConnectionFromPath();
    }
  }

  persistEnterpriseConnectionFromPath() {
    const connection = getEnterpriseConnectionWithPathname(this.props.location.pathname);
    if (connection) {
      saveEnterpriseConnection(connection);
    }
  }

  render() {
    const { authUser, isTokenExpired } = this.props;

    if (isTokenExpired) {
      return (
        <LoadingPage>
          <LoginPage appAuth={this.appAuth} />
        </LoadingPage>
      );
    }

    if (!authUser) {
      return <LoadingPage />;
    }

    return <ForgeOptOutHandler>{this.props.children}</ForgeOptOutHandler>;
  }
}

const Connected = connect(mapStateToProps, {})(BaseLayer);
export default withRouter(Connected);
